import { createTheme } from '@material-ui/core/styles';
import { Overrides } from '@material-ui/core/styles/overrides';

import { MuiInputBase } from 'styles/overrides/MuiInputBase';
import { MuiContainer } from 'styles/overrides/MuiContainer';
import i18n from 'locales/i18n';

const getOverrides = (): Overrides => ({
  MuiContainer,
  MuiInputBase,
});

const getDefaultFont = () => {
  const direction = i18n.dir()
  const poppins = ['Poppins', 'Roboto', 'Open Sans', 'sans-serif'].join(',')
  const notoSansArabic = ['NotoSansArabic', 'Roboto', 'Open Sans', 'sans-serif'].join(',')
  return direction === "rtl" ? notoSansArabic: poppins
}

export default createTheme({
  direction: i18n.dir(),
  palette: {
    primary: {
      light: '#00e0db',
      main: '#00B2AE',
      dark: '#008683',
      contrastText: '#fff',
    },
    background: {
      default: '#fafafa',
      paper: '#FFFFFF',
    },
    secondary: {
      light: '#4a83f1',
      main: '#3F7AEC',
      dark: '#2066ec',
      contrastText: '#fff',
    },
    grey: {
      '900': '#D9DBDD',
      '800': '#DDDFE1',
      '700': '#DCDCDC',
      '600': '#CCCCCC',
      '500': '#707070',
      '400': '#6E6E6E',
      '300': '#787878',
      '200': '#C5C5C5',
      '100': '#444444',
      '50': '#D4D4D4',
      A100: '#A4A4A4',
      A200: '#85899F',
      A400: '#272727'
    },
    text: {
      primary: '#393939',
      secondary: '#6E6E6E',
    },
  },
  typography: {
    h1: {
      fontWeight: 'bold',
      fontSize: '60px',
      lineHeight: '90px',
    },
    h2: {
      fontWeight: 'bold',
      fontSize: '40px',
      lineHeight: '60px',
    },
    h3: {
      fontWeight: 600,
      fontSize: '28px',
      lineHeight: '42px',
    },
    h4: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '30px',
    },
    h5: {
      fontWeight: 300,
      fontSize: '18px',
    },
    h6: {
      fontWeight: 300,
      fontSize: '16px',
    },
    body1: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '27px',
    },
    body2: {
      fontWeight: 300,
      fontSize: 14,
      lineHeight: '21px',
    },
    subtitle1: {
      fontWeight: 300,
      fontSize: 14,
      lineHeight: '21px',
    },
    subtitle2: {
      fontWeight: 300,
      fontSize: 12,
    },
    fontFamily: getDefaultFont(),
  },
  spacing: 2,
  overrides: getOverrides(),
});
